
import React, { Component } from 'react';
import PropTypes from 'prop-types';
const propTypes = {
  url: PropTypes.string,
};
class LoadBotJs extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    let { url } = this.props;
    const script = document.createElement("script");
    //The left side will be covered and the z-index will need to be modified
    script.src =
      url ||
      "https://chatwidget.kodif.io/widget.js?appId=85935fa9-35ee-4a26-ba39-8b1f486981cc&appPosition=right";
    script.async = true;
    document.body.appendChild(script);
    console.info("script is load");
    const startTime = Date.now();
    script.onload = () => {
      const endTime = Date.now();
      console.info("Time spent by bot script is ", ((endTime - startTime) / 1000));
    }
  }
  render() {
    return (
      <></>
    );
  }
}
LoadBotJs.propTypes = propTypes;
export default LoadBotJs;



// WEBPACK FOOTER //
// ./client/components/common/LoadBotJs.jsx